import { graphql, useStaticQuery } from 'gatsby';

export const crewImagesQuery = () => {
  return useStaticQuery(graphql`
    query {
      allImageSharp(filter: { original: { src: { regex: "/crew/" } } }) {
        edges {
          node {
            fluid(maxWidth: 200, quality: 80) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
              originalName
            }
          }
        }
      }
    }
  `);
};
